import { registerDecorator } from 'class-validator';
const iso88591NonControl = /^[\x20-\x7E\xA0-\xFF]+$/;
const iso88591NonControlWithNewLine = /^[\x20-\x7E\xA0-\xFF\t\r\n]+$/;
/**
 * Supported line mode affects the type of validation that this validator will use
 * SINGLE: Useful for textbox inputs - Matches non iso88591NonControl characters
 * MULTI: Useful for textarea inputs - Matches iso88591NonControl characters and allows new lines
 */
export var SupportedLineMode;
(function (SupportedLineMode) {
    SupportedLineMode["SINGLE"] = "single";
    SupportedLineMode["MULTI"] = "multi";
})(SupportedLineMode || (SupportedLineMode = {}));
export const NON_EMPTY_SINGLE_LINE = iso88591NonControl;
export const NON_EMPTY_MULTI_LINE = iso88591NonControlWithNewLine;
/**
 * The intention is for this validator to eventually be used on all text related fields.
 *
 * Currently supports (ISO 8559-1/Windows-1252):
 * - ASCII (No control characters or line breaks)
 * - Latin1-Supplement
 *
 * Popular Languages Covered (See https://en.wikipedia.org/wiki/ISO/IEC_8859-1):
 * - Albanian
 * - Finnish
 * - Danish
 * - French
 * - German
 * - Irish
 * - Italian
 * - Spanish
 * - Swedish
 * - Portuguese
 * - Norwegian
 * - Tagalog
 *
 * Note: We may want to extend this to ISO_8859-15 as there are a couple of characters which we may want in the future.
 */
export function IsSupportedText(mode, property, validationOptions) {
    return function (object, propertyName) {
        const regex = mode === SupportedLineMode.SINGLE ? NON_EMPTY_SINGLE_LINE : NON_EMPTY_MULTI_LINE;
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [property],
            validator: {
                validate(value, _) {
                    if (typeof value !== 'string') {
                        return false;
                    }
                    // we allow empty input
                    if (value === '') {
                        return true;
                    }
                    if (value.trim().length === 0) {
                        return false;
                    }
                    return regex.test(value);
                },
                defaultMessage(args) {
                    const value = args === null || args === void 0 ? void 0 : args.value;
                    if (typeof value !== 'string') {
                        return 'Value provided is not a string';
                    }
                    if (value.trim().length === 0) {
                        return 'Value provided must contain non-space characters';
                    }
                    const badChars = value
                        .split('')
                        .filter(x => !iso88591NonControl.test(x))
                        .map(c => `${c}:${c.charCodeAt(0)}`)
                        .join(', ');
                    return `The following characters are not supported (${badChars})`;
                },
            },
        });
    };
}
